
/**
 * Define all routes which should have page-specific components loaded.
 * 
 * Usually that is page root component which implement page-specific logic
 * like modal handling, etc.
 * 
 * Components from the directory ./components/views will be loaded.
 * For example for route `users.index` page component should be
 * `./components/views/users/Index.vue`
 * 
 * After defining page component in this list it is possible to use it in
 * Blade template via `<users-index-view></users-index-view>` component.
 */

export default [
    'users.index',
    'users.edit',
    'users.create',
    'users.show',
    'users.security',
    'users.agenda',
    
    'roles.index',
    
    'reports.index',

    'departments.index',
    
    'positions.index',
    
    'graduate-profiles.index',
    'master-programs.index',
    
    'groups.regular.index',
    'groups.optional.index',
    'groups.linguistic.index',
    'groups.graduate.index',
    'groups.master.index',
    'groups.bachelor.index',
    'groups.show',

    'subjects.index',
    'subjects.create',
    'subjects.edit',
    'subjects.show',

    'schedule.index',
    'schedule.show',
    'schedule.load',

    'schedule.entries.show',

    'classrooms.index',

    'surveys.index',
    'surveys.edit',
    'surveys.show',
    'surveys.results',
    'surveys.participants',
    'surveys.score-manager',

    'help.index',

    'library.index',

    'news.index',
    'news.edit',
]



// WEBPACK FOOTER //
// ./resources/assets/js/views.js